import { useState } from "react";
import { api } from "../../../../../../../../../utility/api";

export const SobranteReclasificacionApi = () => {
    const [cargando, setCargando] = useState(false);

    const getSobrantesReclasificacion = async (params) => {
        try {
            setCargando(true);
            const response = await api.get(`sobrante_reclasificacion`, params);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    return {
        getSobrantesReclasificacion,

        cargando,
    };
};
